import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { ENV } from '@/config/constants';

const IntroductionBenefitFeeIosPage = () => {
  const [searchParams] = useSearchParams();
  
  // 根据 URL 参数判断登录状态
  const isLogin = searchParams.get('isLogin') === '1';
  
  // Brand IDs based on environment
  const brandIds = ENV === 'prod' 
    ? [
        '9eb135c2-3376-4df7-8e2f-123d604f10f7', // Brand 1
        '01990f2d-372a-7158-8a9c-da088876707d', // Brand 2
        '019951e5-2b2a-74de-bac8-69ec3fb58f18', // Brand 3
        '0199129c-3541-73ae-be22-37d3478ab3fc', // Brand 4
      ]
    : [
        '9eb135c2-3376-4df7-8e2f-123d604f10f7', // Brand 1
        '019a0098-a9b6-79a5-8e75-e4f314f1d874', // Brand 2
        '019a2577-f4cb-7f89-bba2-4404d56fc765', // Brand 3
        '01992968-5b31-7b51-8537-8108df7bb4a2', // Brand 4
      ];

  return (
    <div className="min-h-screen w-full bg-[#f4f4f4] overflow-x-hidden">
      <style jsx>{`
        img {
          user-drag: none;
          -webkit-user-drag: none;
        }
      `}</style>
      
      {/* Hero Section */}
      <section className="w-full relative">
        <img
          src="/images/introduction/benefit_banner_ios.png"
          alt="DONDONスタートガイド for ビギナーズ"
          className="w-full h-auto object-cover"
          draggable="false"
        />
      </section>

      {/* Campaign Card Section */}
      <section className="w-full bg-white h-[162px] flex flex-col items-center justify-center">
        <div className="w-full px-4 flex flex-col items-start">
          {/* First Row */}
          <div className="h-[30px] flex items-center">
            <div className="w-[3px] bg-[#AAAAAA] rounded-[2px] h-full"></div>
            <span className="ml-[10px] font-bold text-[20px] text-black font-['Noto_Sans_JP']">
              キャンペーン内容
            </span>
          </div>
          
          {/* Second Row */}
          <div className="mt-[10px] text-[14px] text-black font-['Noto_Sans_JP']">
            <span className="font-normal">本キャンペーンでは、会員登録後初めて出品した方に</span>
            <span className="font-bold text-[#FF6A00]">もれなく500円分のボーナス金をプレゼントします！</span>
          </div>
        </div>
      </section>

      {/* Second Section */}
      <section className="w-full bg-[#FFF8F2] py-[40px] flex flex-col items-center">
        <div className="w-full px-4 flex flex-col gap-5">
          {/* First Row - Title */}
          <div className="h-[30px] flex items-center">
            <div className="w-[3px] bg-[#FF6A00] rounded-[2px] h-full"></div>
            <span className="ml-[10px] font-bold text-[20px] text-black font-['Noto_Sans_JP']">
              キャンペーン参加方法
            </span>
          </div>

          {/* Cards Container */}
          <div className="flex flex-col gap-0">
            {/* First Card - Step 1: Member Registration with bottom image */}
            <div className="flex flex-col">
              <div className="w-full bg-white border border-[#FF6A00] rounded-[10px] flex flex-col overflow-hidden relative z-20">
                {/* Top: Orange block with number and text */}
                <div className="bg-[#FF6A00] rounded-t-[10px] h-[47px] flex items-center">
                  <img
                    src="/images/introduction/benefit_fee_one.svg"
                    alt="1"
                    className="w-[10px] h-[24px] ml-[16px] object-contain"
                    draggable="false"
                  />
                  <span className="text-white font-['Noto_Sans_JP'] font-bold text-[18px] leading-[150%] ml-[20px]">会員登録</span>
                </div>
                
                {/* Bottom: Text content and button */}
                <div className="flex items-center px-4 h-[122px]">
                  {/* Left: Text content */}
                  <div className="flex-1 font-['Noto_Sans_JP'] font-normal text-[14px] leading-[150%] text-[#111111]">
                    まずは無料の会員登録！<br/>
                    メールアドレスがあればすぐに始められます。
                  </div>
                  
                  {/* Right: Circular button */}
                  {!isLogin && (
                    <a 
                      href="/signup"
                      className="w-[102px] h-[102px] bg-[#FF6A00] rounded-full flex items-center justify-center px-4 flex-shrink-0 cursor-pointer hover:opacity-90 transition-opacity no-underline"
                    >
                      <span className="text-white font-bold text-center font-['Noto_Sans_JP'] text-[14px] leading-[150%]">
                        会員登録は<br/>こちらから
                      </span>
                    </a>
                  )}
                </div>
              </div>

              {/* Bottom decoration image */}
              <div className="flex justify-center relative z-10">
                <img
                  src="/images/introduction/benefit_bottom_border.svg"
                  alt=""
                  className="h-auto -mt-[1px]"
                  draggable="false"
                />
              </div>
            </div>

            {/* Second Card - Step 2: First Listing with bottom image */}
            <div className="flex flex-col -mt-[5px] z-0">
              <div className="w-full bg-white border border-[#FF6A00] rounded-[10px] flex flex-col overflow-hidden relative">
                {/* Top: Orange block with number and text */}
                <div className="bg-[#FF6A00] rounded-t-[10px] h-[47px] flex items-center">
                  <img
                    src="/images/introduction/benefit_fee_two.svg"
                    alt="2"
                    className="w-[15px] h-[24px] ml-[16px] object-contain"
                    draggable="false"
                  />
                  <span className="text-white font-['Noto_Sans_JP'] font-bold text-[18px] leading-[150%] ml-[20px]">初出品</span>
                </div>
                
                {/* Bottom: Text content */}
                <div className="flex flex-col px-4 pt-5 pb-4">
                  <div className="font-['Noto_Sans_JP'] font-normal text-[14px] leading-[150%] text-[#111111]">
                    出品は1点からOK！お好きなブランド・カテゴリで参加できます。
                  </div>
                  
                  {/* Content area below text */}
                  <div className="w-full bg-[#F4F4F4] rounded-[10px] mt-5 pt-[10px] px-4 pb-[10px]">
                    <div className="flex flex-col items-center">
                      <div className="text-center font-['Noto_Sans_JP'] font-bold text-[14px] leading-[150%] text-[#111111]">
                        商品一覧を見る
                      </div>
                      
                      {/* Second row: Four brand images - responsive grid */}
                      <div className="grid grid-cols-2 gap-[10px] mt-[10px] w-full">
                        <a 
                          href={`/brands/${brandIds[0]}`}
                          className="w-full h-auto no-underline"
                        >
                          <img
                            src="/images/introduction/benefit_brand_ios1.png"
                            alt="Brand 1"
                            className="w-full h-auto object-contain cursor-pointer hover:opacity-80 transition-opacity"
                            draggable="false"
                          />
                        </a>
                        <a 
                          href={`/brands/${brandIds[1]}`}
                          className="w-full h-auto no-underline"
                        >
                          <img
                            src="/images/introduction/benefit_brand_ios2.png"
                            alt="Brand 2"
                            className="w-full h-auto object-contain cursor-pointer hover:opacity-80 transition-opacity"
                            draggable="false"
                          />
                        </a>
                        <a 
                          href={`/brands/${brandIds[2]}`}
                          className="w-full h-auto no-underline"
                        >
                          <img
                            src="/images/introduction/benefit_brand_ios3.png"
                            alt="Brand 3"
                            className="w-full h-auto object-contain cursor-pointer hover:opacity-80 transition-opacity"
                            draggable="false"
                          />
                        </a>
                        <a 
                          href={`/brands/${brandIds[3]}`}
                          className="w-full h-auto no-underline"
                        >
                          <img
                            src="/images/introduction/benefit_brand_ios4.png"
                            alt="Brand 4"
                            className="w-full h-auto object-contain cursor-pointer hover:opacity-80 transition-opacity"
                            draggable="false"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Bottom decoration image */}
              <div className="flex justify-center relative z-10">
                <img
                  src="/images/introduction/benefit_card_bottom.svg"
                  alt=""
                  className="h-auto"
                  draggable="false"
                />
              </div>

              {/* Background image - fixed position at -24px below triangle */}
              <div className="h-0 relative -mt-[24px]">
                <div className="absolute left-0 right-0 top-0 flex justify-center z-0 px-[7.25px]">
                  <img
                    src="/images/introduction/benefit_dot_ios.png"
                    alt=""
                    className="w-full h-auto"
                    draggable="false"
                  />
                </div>
              </div>

              {/* Third content area */}
              <div className="flex flex-col items-center relative z-10 mt-[40px]">
                {/* First row */}
                <div className="font-['Noto_Sans_JP'] font-normal text-[14px] leading-[170%] text-[#111111]">
                  売上金と同様に使用できる
                </div>

                {/* Second row */}
                <div className="font-['Noto_Sans_JP'] font-bold text-[20px] leading-[150%] text-[#FF6A00]">
                  500円分のボーナス金をGET
                </div>

                {/* Third row */}
                <div className="mt-[5px] font-['Noto_Sans_JP'] text-center font-normal text-[10px] leading-[150%] text-[#111111] origin-top">
                  出品完了後すぐにボーナス金が付与されます。<br/>
                  「マイページ→ 売上・振込申請管理」ページにてご確認ください。
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Third Section */}
      <section className="w-full bg-white py-[40px] flex flex-col items-center">
        <div className="w-full px-4 flex flex-col">
          {/* First Row - Title */}
          <div className="h-[30px] flex items-center">
            <div className="w-[3px] bg-[#AAAAAA] rounded-[2px] h-full"></div>
            <span className="ml-[10px] font-bold text-[20px] text-black font-['Noto_Sans_JP']">
              注意事項
            </span>
          </div>

          {/* Second Row - Unordered List */}
          <ul className="mt-[10px] list-none flex flex-col gap-0 font-['Noto_Sans_JP'] font-normal text-[14px] leading-[170%] text-[#111111]">
            <li className="flex items-start">
              <div className="w-[24px] h-[24px] flex items-center justify-center flex-shrink-0">
                <div className="w-[4px] h-[4px] bg-[#111111] rounded-full"></div>
              </div>
              <span>本ボーナス金の付与は、各ユーザー1回限りとなります。</span>
            </li>
            <li className="flex items-start">
              <div className="w-[24px] h-[24px] flex items-center justify-center flex-shrink-0">
                <div className="w-[4px] h-[4px] bg-[#111111] rounded-full"></div>
              </div>
              <span>ボーナス金のみでの振込申請はできません。売上金と合算して1,000円以上となった場合に振込申請が可能です。なお、ボーナス金は商品の購入や注文金額の割引には利用できません。</span>
            </li>
            <li className="flex items-start">
              <div className="w-[24px] h-[24px] flex items-center justify-center flex-shrink-0">
                <div className="w-[4px] h-[4px] bg-[#111111] rounded-full"></div>
              </div>
              <span>ボーナス金を出金する際は、売上金の振込申請と同じ条件が適用されます。。</span>
            </li>
            <li className="flex items-start">
              <div className="w-[24px] h-[24px] flex items-center justify-center flex-shrink-0">
                <div className="w-[4px] h-[4px] bg-[#111111] rounded-full"></div>
              </div>
              <span>ボーナス金の受取後72時間以内に該当商品を削除した場合、ボーナス金は自動的に取消が行われます。取消の反映にはタイムラグが生じる場合があります。 詳細は「売上・振込申請管理」にてご確認ください。</span>
            </li>
            <li className="flex items-start">
              <div className="w-[24px] h-[24px] flex items-center justify-center flex-shrink-0">
                <div className="w-[4px] h-[4px] bg-[#111111] rounded-full"></div>
              </div>
              <span>重複アカウントや規約違反に該当する出品等が確認された場合、ボーナス金の取消および回収を行う場合があります。</span>
            </li>
            <li className="flex items-start">
              <div className="w-[24px] h-[24px] flex items-center justify-center flex-shrink-0">
                <div className="w-[4px] h-[4px] bg-[#111111] rounded-full"></div>
              </div>
              <span>ボーナス金の有効期限は付与日から180日間です。期限を過ぎると自動的に失効しますのでご注意ください。</span>
            </li>
            <li className="flex items-start">
              <div className="w-[24px] h-[24px] flex items-center justify-center flex-shrink-0">
                <div className="w-[4px] h-[4px] bg-[#111111] rounded-full"></div>
              </div>
              <span>ボーナス金の利用規則は、運営方針により変更または終了する場合があります。</span>
            </li>
            <li className="flex items-start">
              <div className="w-[24px] h-[24px] flex items-center justify-center flex-shrink-0">
                <div className="w-[4px] h-[4px] bg-[#111111] rounded-full"></div>
              </div>
              <span>本キャンペーンの開始および終了時期は、運営状況により変更となる場合があります。詳細は、バナーまたはメッセージセンターにて通知が行われます。</span>
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default IntroductionBenefitFeeIosPage;
